import { maunaSpaceAPI } from '@/api';
import CommonSpaceDetailContainer, {
  FieldConfig,
} from '@/components/common/CommonSpaceDetailContainer';
import MaunaHeader from './MaunaHeader';
import { palette } from '@/modules/defines/styles';

interface DataType {
  id?: number;
  publish: boolean;
  title: string;
  description: string;
  category: number;
  floor: string | null;
  img: string;
  detail: any;
  link: string;
  link_faview: string;
  latlng: string;
  sgroup_id: number | null;
  createdAt?: string;
  updatedAt?: string;
}

const categoryMap: { [key: string]: string } = {
  '1': '객실',
  '2': '다이닝',
  '3': '부대시설',
  '4': '웨딩&연회',
};

const fields: FieldConfig<DataType>[] = [
  {
    name: 'title',
    label: '이름',
    type: 'text',
    description: '공간의 이름을 입력해주세요',
    width: 'full',
  },
  {
    name: 'description',
    label: '설명',
    type: 'textarea',
    description: '공간에 대한 자세한 설명을 입력해주세요',
    width: 'full',
  },
  {
    name: 'category',
    label: '카테고리',
    type: 'select',
    options: Object.entries(categoryMap).map(([key, value]) => ({
      value: key,
      label: value,
    })),
    description: '공간의 카테고리를 선택해주세요',
    width: 'half',
    isNumber: true,
  },
  {
    name: 'floor',
    label: '층수',
    type: 'text',
    placeholder: '층수를 입력하세요',
    description: '공간이 위치한 층수를 입력해주세요 (선택사항)',
    width: 'half',
  },
  {
    name: 'img',
    label: '이미지',
    type: 'image',
    description: '공간의 대표 이미지를 업로드해주세요',
    width: 'full',
  },
  {
    name: 'link',
    label: '링크',
    type: 'text',
    description: '공간과 관련된 웹페이지 링크를 입력해주세요',
    width: 'full',
  },
  {
    name: 'link_faview',
    label: 'Faview 링크',
    type: 'text',
    description: 'Faview 뷰어 링크를 입력해주세요',
    width: 'full',
  },
  {
    name: 'latlng',
    label: '위도/경도',
    type: 'text',
    placeholder: '위도,경도 형식으로 입력',
    description: '위치 좌표를 입력해주세요 (예: 37.1234,127.5678)',
    width: 'full',
  },
];

const MaunaSpaceDetailContainer = () => {
  return (
    <CommonSpaceDetailContainer<DataType>
      HeaderComponent={MaunaHeader}
      queryKey="getSpaceMauna"
      listQueryKey="getSpacesMauna"
      queryFn={(id) =>
        maunaSpaceAPI.getSpace({
          code: import.meta.env.VITE_SECRET_API_KEY,
          id,
        })
      }
      updateFn={(id, data) =>
        maunaSpaceAPI.updateSpace(
          {
            code: import.meta.env.VITE_SECRET_API_KEY,
            id,
          },
          data
        )
      }
      fields={fields}
      switchFieldKey="publish"
      switchFieldLabel="앱에서 사용"
      defaultRoute="/mauna/space"
      themeColor={palette.systemGreen}
      themeHoverColor="#3e8e41"
      uploadImageFn={(id, file) => maunaSpaceAPI.uploadImage(id, file)}
    />
  );
};

export default MaunaSpaceDetailContainer;
